export default "__VITE_ASSET__dPwr8vm8__"